import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import styled from '@emotion/styled';

const StyledAlert = styled(Alert)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const DeactivatedAlert = ({ entityType, parentInactive, parentName }) => {
    const label = entityType === 'client' ? 'Client' : 'Account';
    const title = parentInactive ? 'Parent Client Deactivated' : `${label} Deactivated`;
    const body = parentInactive
        ? `The parent client${parentName ? ` "${parentName}"` : ''} is deactivated. Please confirm work on these projects can proceed.`
        : `This ${entityType} is deactivated. Please confirm work on these projects can proceed.`;

    return (
        <StyledAlert severity="warning">
            <AlertTitle>{title}</AlertTitle>
            {body}
        </StyledAlert>
    );
};

export default DeactivatedAlert;
